// extracted by mini-css-extract-plugin
export default {"container":"Qaa-z","oos":"Raa-z","oosUx":"Saa-z","selected":"Taa-z","labelOos":"Uaa-z"};